import { render } from "./PageComponents.vue?vue&type=template&id=7200983c"
import script from "./PageComponents.vue?vue&type=script&lang=js"
export * from "./PageComponents.vue?vue&type=script&lang=js"

import "./PageComponents.vue?vue&type=style&index=0&id=7200983c&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/Genesii/COLON/wonderful-colon/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__